(function () {
    "use strict";

    angular.module("app").component("habilMultiSelect", {
        transclude: true,
        templateUrl: "@/multi-select/multi-select.template.html",
        bindings: {
            options: "<",
            selectionChanged: "&",
            selectionChangedWithOption: "=?",
            settings: "="
        },
        controller: MultiSelectComponent
    });

    function MultiSelectComponent() {
        const defaultSettings = {
            FilterKey: "Value",
            SortFunction: (item) => Number.parseInt(item.Key)
        };

        const $controller = this;

        $controller.OptionChanged = optionChanged;

        $controller.Filter = getFilterFunction();
        $controller.Sort = getSortFunction();

        function optionChanged(option) {
            if (angular.isFunction($controller.selectionChangedWithOption)) {
                $controller.selectionChangedWithOption(option);
            }
        }

        function getFilterFunction() {
            const key = readSetting("FilterKey");
            return function createFilter(needle) {
                const filter = {};
                filter[key] = needle;
                return filter;
            };
        }

        function getSortFunction() {
            return readSetting("SortFunction");
        }

        function readSetting(setting) {
            if (!$controller.settings)
                return defaultSettings[setting];

            return { ...defaultSettings, ...$controller.settings }[setting];
        }
    }
})();
